import React, {useMemo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/src/shape-component"
import {ContactRelationship} from "models"
import {initialsForUser} from "shared/initials"
import memo from "set-state-compare/src/memo"
import OptionsButton from "./options-button"
import PropTypes from "prop-types"
import propTypesExact from "prop-types-exact"
import {Text} from "shared/base"
import {View} from "react-native"

export default memo(shapeComponent(class ComponentsUserAdminSchoolClassesIndexUserCircle extends ShapeComponent {
  static defaultProps = {
    backgroundColor: null,
    style: null
  }

  static propTypes = propTypesExact({
    backgroundColor: PropTypes.string,
    schoolClassRole: PropTypes.instanceOf(ContactRelationship).isRequired,
    style: PropTypes.object
  })

  render() {
    const {backgroundColor, schoolClassRole, style} = this.p
    const actualStyle = useMemo(() => Object.assign(
      {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 252,
        height: 252,
        backgroundColor,
        borderRadius: "50%"
      },
      style
    ), [style])

    return (
      <View dataSet={this.cache("roleCircleDataSet", {class: "role-circle", roleId: schoolClassRole.id()}, [schoolClassRole.id()])} style={actualStyle}>
        <OptionsButton schoolClassRole={schoolClassRole} style={this.optionsButtonStyle ||= {position: "absolute", right: 25, bottom: 72}} />
        <Text style={this.userInitialsStyle ||= {color: "#fff", fontSize: 70}}>
          {initialsForUser(schoolClassRole.child().user())}
        </Text>
        <Text style={this.userNameStyle ||= {marginTop: 30, color: "#fff", fontSize: 16}}>
          {schoolClassRole.child().user().name()}
        </Text>
        <Text
          dataSet={this.contactRelationshipTypeDataSet ||= {class: "school-class-role-translated-role"}}
          style={this.contactRelationshipTypeStyle ||= {marginTop: 6, fontSize: 18}}
        >
          {schoolClassRole.contactRelationshipType().translatedIdentifier()}
        </Text>
      </View>
    )
  }
}))
